module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("17xsx"))).then(() => parcelRequire('hEqeo'));